import React, { useState, useRef, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import {
  Typography,
  Switch,
  CardActions,
  Box,
  Button,
  Input,
  InputLabel,
  FormControl,
  Avatar,
  Fade,
  IconButton,
  Popper
} from "@material-ui/core/"
import Skeleton from "@material-ui/lab/Skeleton"
import SideBox from "../../../SideBox"
import { Formik, Form } from "formik"
import MaskedMobileInput from "components/MaskedMobileInput"
import cloudinary from "cloudinary-core"
import { setNeedsApproval, addUser } from "actions/organization"
import { checkForUser, inviteUser } from "actions/user"
import { openSnackBar } from "actions/snack-bar"
import FileCopyIcon from "@material-ui/icons/FileCopy"
import LoaderButton from "components/LoaderButton"
import Notifications from "../../../../components/SideBox/components/Notifications/indes"

const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const InviteLink = ({ classes }) => {
  const formRef = useRef()
  const dispatch = useDispatch()
  const currentOrg = useSelector(state => state.organization.currentOrg)
  const isAdminNotified = useSelector(
    state => state.organization.currentOrg.post_notify_admin
  )
  const isModeratorNotified = useSelector(
    state => state.organization.currentOrg.post_notify_mod
  )
  const [switchValue, setSwitchValue] = useState()
  const [disableSwitch, setDisableSwitch] = useState(false)
  const [member, setMember] = useState(null)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [working, setWorking] = useState(false)

  // const handleClick = e => {
  //   e.preventDefault()
  //   window.location = `/register?code=${currentOrg.code}`
  // }

  const handleAddMember = () => {
    setWorking(true)
    dispatch(addUser(member.id))
      .then(res => {
        setWorking(false)
        formRef.current.resetForm()
        setMember(null)
        if (res.body.error) {
          dispatch(openSnackBar({ message: res.body.message }))
        }
      })
      .catch(error => {
        setWorking(false)
        formRef.current.resetForm()
        dispatch(openSnackBar({ message: "Error: Could not add member." }))
      })
  }

  const handleInviteUser = userPhone => {
    setWorking(true)
    dispatch(inviteUser(userPhone))
      .then(res => {
        setWorking(false)
        formRef.current.resetForm()
        setMember(null)
        dispatch(openSnackBar({ message: `Invite sent to ${userPhone}.` }))
      })
      .catch(error => {
        formRef.current.resetForm()
        setMember(null)
        dispatch(openSnackBar({ message: `Failed to send invite.` }))
      })
  }

  const handleCancel = () => {
    setMember(null)
    formRef.current.resetForm()
  }

  useEffect(() => {
    setSwitchValue(Boolean(currentOrg.needs_approval))
  }, [currentOrg])

  const handleChangeSwitch = () => {
    setDisableSwitch(true)
    dispatch(setNeedsApproval(currentOrg.id, !switchValue))
      .then(() => {
        setDisableSwitch(false)
        setSwitchValue(!switchValue)
      })
      .catch(err => {
        dispatch(openSnackBar({ message: err.message }))
        setDisableSwitch(false)
      })
  }

  const host = window.location.host.split(".")
  let registerLink

  if (host.length === 3) {
    registerLink = `https://${currentOrg.subdomain}.${host[1]}.${host[2]}/register?code=${currentOrg.code}`
  } else {
    registerLink = `https://${currentOrg.subdomain}.${host[0]}.${host[1]}/register?code=${currentOrg.code}`
  }

  const handleCopy = e => {
    const el = document.createElement("textarea")
    el.value = registerLink
    document.body.appendChild(el)
    el.select()
    document.execCommand("copy")
    document.body.removeChild(el)

    setAnchorEl(anchorEl ? null : e.currentTarget)

    setTimeout(() => {
      setAnchorEl(null)
    }, 2000)
  }

  return (
    <Box className={classes.inviteLinkContainer}>
      <SideBox
        title="Required Approval"
        content={
          <CardActions className={classes.actions}>
            <Box display="flex" flexDirection="row">
              <Switch
                checked={Boolean(switchValue)}
                onChange={handleChangeSwitch}
                color="primary"
                disabled={Boolean(disableSwitch)}
              />
              <div className="approbalContainer">
                <Typography color="secondary">
                  Members cannot post until an administrator has approved their
                  account
                </Typography>
              </div>
            </Box>
          </CardActions>
        }
      />
      <Notifications
        isAdminNotified={isAdminNotified === 1 ? true : false}
        isModeratorNotified={isModeratorNotified === 1 ? true : false}
        orgId={currentOrg.id}
      />
      <SideBox
        title={"INVITE LINK"}
        subtitle={
          "You can publish this link and code to allow members to join your organization themselves"
        }
        content={
          <Box>
            <CardActions className={classes.actions}>
              <Box className={classes.link}>
                <Typography variant="h6">Register Link</Typography>
                <Box display="flex" justifyContent="space-between">
                  <Box
                    style={{
                      width: "80%",
                      maxWidth: "80%",
                      wordWrap: "break-word"
                    }}
                  >
                    <a
                      href={registerLink}
                      target="_blank"
                      className={classes.linkText}
                    >
                      <Typography>{registerLink}</Typography>
                    </a>
                  </Box>
                  <Box style={{ width: "10%" }}>
                    <IconButton onClick={handleCopy}>
                      <FileCopyIcon
                        className={classes.copyIcon}
                        color="secondary"
                      />
                    </IconButton>
                  </Box>
                </Box>
                <Popper open={Boolean(anchorEl)} anchorEl={anchorEl} transition>
                  {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                      <div className={classes.registerCopy}>
                        <Typography align="center">
                          Register URL copied.
                        </Typography>
                      </div>
                    </Fade>
                  )}
                </Popper>
              </Box>
              <Box className={classes.codeContainer}>
                <Typography variant="h6">Organization Code</Typography>
                <Typography
                  variant="h4"
                  color="secondary"
                  className={classes.code}
                >
                  {currentOrg.code}
                </Typography>
              </Box>
              <Box className={classes.addMember}>
                <Typography variant="h6">Add Member By Phone</Typography>
                <Formik
                  innerRef={formRef}
                  initialValues={{ phoneNumber: "" }}
                  // validationSchema={inviteMemberSchema}
                  onSubmit={(values, { resetForm }) => {
                    dispatch(checkForUser(values.phoneNumber))
                      .then(res => {
                        if (res.error && res.data) {
                          resetForm()
                          return dispatch(
                            openSnackBar({
                              message: res.error
                            })
                          )
                        }

                        if (res.data !== null) {
                          return setMember({ ...res.data, exists: true })
                        } else {
                          return setMember({
                            first_name: values.phoneNumber,
                            last_name: "",
                            exists: false
                          })
                        }
                      })
                      .catch(error => {
                        resetForm()
                        dispatch(
                          openSnackBar({
                            message: "Error: Could not add member."
                          })
                        )
                      })
                    // handleSearch(values.phoneNumber)

                    // document.getElementById("phoneNumber").focus()
                  }}
                >
                  {({ values, handleChange, handleBlur, handleSubmit }) => (
                    <Form className={classes.addMemberForm}>
                      <Box className={classes.hashtagsContainer}>
                        <FormControl
                          // error={errors.hashtag && touched.hashtag}
                          className={classes.hashtagsContainer}
                        >
                          <Box display="flex">
                            <Box>
                              <InputLabel
                                className={classes.hashtagTitle}
                                htmlFor="phoneNumber"
                              >
                                <Typography
                                  variant="h5"
                                  className={classes.searchText}
                                >
                                  Search
                                </Typography>
                              </InputLabel>
                              <Input
                                className={classes.phoneNumberInput}
                                name="phoneNumber"
                                id="phoneNumber"
                                value={values.phoneNumber}
                                onChange={e => {
                                  const valueLength = e.target.value.length
                                  handleChange(e)
                                  if (valueLength === 14) {
                                    handleSubmit()
                                  }
                                }}
                                onBlur={handleBlur}
                                inputComponent={MaskedMobileInput}
                                disabled={
                                  Boolean(member) ||
                                  Boolean(values.phoneNumber >= 14)
                                }
                              />
                              {/* <FormHelperText className={classes.errorContainer}>
                        {touched.hashtag && errors.hashtag}
                           </FormHelperText> */}
                            </Box>
                          </Box>
                        </FormControl>
                        <Box className={classes.searchResults}>
                          {/* Search Result Skeleton */}
                          {(values.phoneNumber.length !== 0 || member) && (
                            <Box>
                              <Fade
                                in={Boolean(!member)}
                                timeout={{ enter: 1000, exit: 2000 }}
                              >
                                <Box display="flex" flexDirection="row">
                                  <Skeleton
                                    variant="circle"
                                    width={60}
                                    height={60}
                                  />
                                  <Box className={classes.rightPhoneResult}>
                                    <Skeleton
                                      variant="text"
                                      width={150}
                                      height={24}
                                    />
                                    <Box
                                      className={classes.phoneResultButtons}
                                      display="flex"
                                      flexDirection="row"
                                    >
                                      <Skeleton
                                        variant="rect"
                                        width={64}
                                        height={24}
                                      />
                                      <Skeleton
                                        variant="rect"
                                        width={64}
                                        height={24}
                                      />
                                    </Box>
                                  </Box>
                                </Box>
                              </Fade>

                              <Fade
                                in={Boolean(member)}
                                timeout={{ enter: 2000, exit: 1000 }}
                              >
                                <Box
                                  display="flex"
                                  flexWrap="wrap"
                                  position="absolute"
                                  top={0}
                                >
                                  <Box>
                                    <Avatar
                                      className={classes.phoneResultAvatar}
                                      src={
                                        member &&
                                        member.profile_image &&
                                        cl.url(
                                          JSON.parse(member.profile_image)
                                            .public_id,
                                          {
                                            width: 100,
                                            crop: "scale"
                                          }
                                        )
                                      }
                                    />
                                  </Box>
                                  <Box className={classes.rightPhoneResult}>
                                    <Typography
                                      variant="subtitle2"
                                      className={classes.nameText}
                                    >
                                      {member &&
                                        `${member.first_name &&
                                          member.first_name} ${member.last_name &&
                                          member.last_name}`}
                                    </Typography>
                                    <Box className={classes.phoneResultButtons}>
                                      <LoaderButton
                                        working={working}
                                        color="primary"
                                        onClick={
                                          /* eslint-disable */
                                          member && member.exists
                                            ? handleAddMember
                                            : () =>
                                                handleInviteUser(
                                                  values.phoneNumber
                                                )
                                          /* eslint-enable */
                                        }
                                      >
                                        {member && member.exists
                                          ? "Add"
                                          : "Invite"}
                                      </LoaderButton>
                                      <Button
                                        className={classes.cancel}
                                        onClick={handleCancel}
                                      >
                                        Cancel
                                      </Button>
                                    </Box>
                                  </Box>
                                  <Box flex="100%" marginTop="16px">
                                    <Typography
                                      align="center"
                                      color="secondary"
                                    >
                                      {member &&
                                        !member.exists &&
                                        "Cannot find user. Select invite to send an invite message to this number."}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Fade>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Form>
                  )}
                </Formik>
              </Box>
            </CardActions>
          </Box>
        }
      />
    </Box>
  )
}

export default withStyles(styles)(InviteLink)



// WEBPACK FOOTER //
// ./src/components/SideBox/components/InviteLink/index.jsx